module.exports = __webpack_public_path__ + "img/napa_green_vineyard.155e3aaa.jpg";